export default "__VITE_ASSET__C4Jnom0___"